var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "dsf_liveDetail" }, [
        _c("div", { staticClass: "live-top" }, [
          _c(
            "div",
            { staticClass: "live-top-inner", attrs: { id: "LiveHeader" } },
            [
              _c("div", { staticClass: "live-top-inner-l" }, [
                _c(
                  "button",
                  {
                    staticClass: "live-btn live-btn-playback",
                    class:
                      _vm.state.value == 0
                        ? "live-btn-appoint"
                        : "live-btn-playback",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.state.value == 1
                            ? "正在直播"
                            : _vm.state.value == 0
                            ? "未开始"
                            : "直播回放"
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "span",
                  {
                    staticClass: "live-title ell",
                    attrs: { title: _vm.liveInfo.title },
                  },
                  [_vm._v(_vm._s(_vm.liveInfo.title || "暂无标题"))]
                ),
              ]),
              _c("div", { staticClass: "live-top-inner-r" }, [
                _c(
                  "div",
                  { staticClass: "dingyue" },
                  [
                    _c("dsf-icon", { staticClass: "icon-yanjing1" }),
                    _c("span", [_vm._v(_vm._s(_vm.views || 0))]),
                    _vm.state.value == 0
                      ? _c(
                          "button",
                          {
                            staticClass: "live-btn live-btn-handle-appoint",
                            on: { click: _vm.liveAppointHandle },
                          },
                          [_vm._v(_vm._s(!_vm.subscribe ? "订阅" : "取消订阅"))]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "live-content" }, [
          _c(
            "div",
            {
              staticClass: "live-box",
              style: { width: _vm.conWidth, height: _vm.playerHeight },
            },
            [
              _vm.getLivePlayer
                ? _c("DsfNcLivePlayer", {
                    attrs: {
                      playerWidth: "100%",
                      isDesign: _vm.isDesign,
                      playerHeight: _vm.playerHeight,
                      channelId: _vm.liveInfo.channelValue,
                      liveInfo: _vm.liveData,
                    },
                  })
                : _vm._e(),
              _vm.videoShow
                ? _c("dsfNcPlayer", {
                    ref: "coursePlayer",
                    attrs: {
                      width: "100%",
                      altTabStop: _vm.altTabStop,
                      hint: false,
                      height: _vm.playerHeight,
                      playerParams: _vm.playerParams,
                      videoSource: _vm.videoSource,
                    },
                    on: {
                      playerPlayingTime: _vm.playerPlayingTime,
                      playerHasPlay: _vm.playerHasPlay,
                      playerHasPause: _vm.playerHasPause,
                      playHasEnd: _vm.playHasEnd,
                    },
                  })
                : _vm._e(),
              _vm.state.value == 0
                ? _c(
                    "div",
                    { staticClass: "live-cover img-box" },
                    [
                      _c("el-image", {
                        attrs: {
                          src: _vm._f("imgFormat")(_vm.liveInfo.cover),
                          fit: "cover",
                        },
                      }),
                      _c("div", { staticClass: "live-time-wrap" }, [
                        _c("div", { staticClass: "live-time-inner" }, [
                          _c("p", { staticClass: "p1" }, [
                            _vm._v(
                              _vm._s(
                                _vm.liveInfo.stateValue == 0
                                  ? "该直播间被停用"
                                  : "未开始"
                              )
                            ),
                          ]),
                          _c("p", { staticClass: "p2" }, [
                            _vm._v(
                              "开播时间: " +
                                _vm._s(
                                  !!_vm.liveInfo.timeSdate
                                    ? _vm.liveInfo.timeSdate
                                    : "开播时间未定"
                                )
                            ),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.getLiveState
                ? _c("div", { staticClass: "live-cover img-box" }, [
                    _vm.liveInfo.stateValue == 0
                      ? _c(
                          "div",
                          [
                            _c("el-image", {
                              attrs: {
                                src: _vm._f("imgFormat")(_vm.liveInfo.cover),
                                fit: "cover",
                              },
                            }),
                            _c("div", { staticClass: "live-time-wrap" }, [
                              _c("div", { staticClass: "live-time-inner" }, [
                                _c("p", { staticClass: "p1" }, [
                                  _vm._v("该直播间被停用"),
                                ]),
                                _c("p", { staticClass: "p2" }, [
                                  _vm._v(
                                    "直播时间: " +
                                      _vm._s(_vm.liveInfo.timeSdate || "")
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        )
                      : _vm.liveInfo.typeValue == 2 &&
                        _vm.state.value !== 0 &&
                        _vm.liveInfo.stateValue != 0
                      ? _c(
                          "div",
                          { staticClass: "pointer" },
                          [
                            _c("el-image", {
                              attrs: {
                                src: _vm._f("imgFormat")(_vm.liveInfo.cover),
                                fit: "cover",
                              },
                            }),
                            _c("div", { staticClass: "live-time-wrap" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "live-time-inner",
                                  on: { click: _vm.goLiveLink },
                                },
                                [
                                  _c("p", { staticClass: "p1" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.state.value === 2 ||
                                          _vm.state.value === 3
                                          ? "回放中"
                                          : "直播中"
                                      )
                                    ),
                                  ]),
                                  _c("p", { staticClass: "p2" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.state.value === 2 ||
                                          _vm.state.value === 3
                                          ? "点击进入回放"
                                          : "点击进入直播"
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          [
                            _c("el-image", {
                              attrs: {
                                src: _vm._f("imgFormat")(_vm.liveInfo.cover),
                                fit: "cover",
                              },
                            }),
                            _c("div", { staticClass: "live-time-wrap" }, [
                              _c("div", { staticClass: "live-time-inner" }, [
                                _c("p", { staticClass: "p1" }, [
                                  _vm._v("直播结束"),
                                ]),
                                _c("p", { staticClass: "p2" }, [
                                  _vm._v(
                                    "直播时间: " +
                                      _vm._s(_vm.liveInfo.timeSdate || "")
                                  ),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c("div", { staticClass: "d-comment-warp" }, [
            _c("div", { staticClass: "d-comment" }, [
              _c("ul", { staticClass: "d-comment-handle" }, [
                _c(
                  "li",
                  {
                    class: { isred: _vm.tag },
                    on: { click: _vm.handleClickTag },
                  },
                  [
                    _c("dsf-icon", {
                      staticClass: "pointer",
                      class: [_vm.tag ? "icon-dianzan1" : "icon-dianzan"],
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "live-dz",
                        attrs: {
                          id: "LiveDz",
                          title: !_vm.tag ? "点赞" : "取消点赞",
                        },
                      },
                      [_vm._v(_vm._s(_vm.tagTotal))]
                    ),
                  ],
                  1
                ),
                _c(
                  "li",
                  {
                    class: { isred: _vm.collect },
                    on: { click: _vm.handleClickCollect },
                  },
                  [
                    _c("dsf-icon", {
                      staticClass: "pointer",
                      class: [
                        _vm.collect ? "icon-aixin_shixin" : "icon-shoucang2 ",
                      ],
                    }),
                    _c(
                      "span",
                      {
                        staticClass: "live-sc",
                        attrs: {
                          id: "LiveSc",
                          title: !_vm.collect ? "收藏" : "取消收藏",
                        },
                      },
                      [_vm._v(_vm._s(_vm.collectTotal))]
                    ),
                  ],
                  1
                ),
                _c("li"),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "tabs" }, [
          _c("div", { staticClass: "con-tab-head-wrap" }, [
            _c(
              "ul",
              { staticClass: "con-tabs", style: { width: _vm.conWidth } },
              _vm._l(_vm.tabs, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class: { tabHasSel: _vm.activeName == index + 1 },
                    on: {
                      click: function ($event) {
                        _vm.activeName = item.id
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(item.name))])]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "tabs-content", style: { width: _vm.conWidth } },
              [
                _vm.activeName == 1
                  ? _c("div", { staticClass: "introduction" }, [
                      _c("div", { staticClass: "introduction-left" }, [
                        _c("h3", { staticClass: "course-tab-title" }, [
                          _vm._v("直播简介"),
                        ]),
                        _c("div", { staticClass: "course-desc-warp" }, [
                          _c(
                            "div",
                            { staticClass: "live-info live-info-bottom" },
                            [
                              _c("div", { staticClass: "live-info-inner" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "live-desc",
                                    attrs: { id: "LiveIntroduction" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "live-info-sub-title" },
                                      [
                                        _c(
                                          "p",
                                          { staticClass: "live-s-title" },
                                          [_vm._v(_vm._s(_vm.liveInfo.title))]
                                        ),
                                        _c(
                                          "p",
                                          { staticClass: "live-s-time" },
                                          [
                                            _vm._v(
                                              "开播时间：" +
                                                _vm._s(
                                                  _vm.formatterDate(
                                                    _vm.liveInfo.timeSdate
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("p", {
                                      staticClass: "live-text",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.liveInfo.content),
                                      },
                                    }),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        { staticClass: "introduction-right" },
                        [_c("DsfNcLiveInformation")],
                        1
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "note-box" },
                  [
                    _vm.activeName == 2
                      ? _c("dsf-nc-note-item", {
                          attrs: {
                            relationId: _vm.liveId,
                            liveCover: _vm.liveCover,
                            relationTitle: _vm.liveInfo.title,
                            isLive: true,
                            btnWidth: "100px",
                            fontColor: "#333",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.activeName == 3
                  ? _c("comment", { staticClass: "note-box" })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
        _vm.mutedPlay
          ? _c("div", { attrs: { id: "isvideo-box" } }, [
              _vm._v(" 是否允许浏览器播放声音? "),
              _c(
                "span",
                {
                  staticClass: "ppt-control-volume-cancel isvideo",
                  on: { click: _vm.handleMuted },
                },
                [_vm._v("播放声音")]
              ),
              _c(
                "span",
                {
                  staticClass: "ppt-control-volume-close isvideoclose",
                  on: {
                    click: function ($event) {
                      _vm.mutedPlay = false
                    },
                  },
                },
                [_vm._v("忽略")]
              ),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }